import { getClientIp } from "./getClientIp";

/** 現在のクライアント IP が VITE_DEBUG_ALLOWED_IPS に含まれるか。未設定・取得失敗は false */
export const checkAllowedIp = async (): Promise<boolean> => {
  const raw = import.meta.env.VITE_DEBUG_ALLOWED_IPS;
  if (!raw) return false;

  const allowedIps = raw
    .split(",")
    .map((ip) => ip.trim())
    .filter(Boolean);
  if (allowedIps.length === 0) return false;

  const ip = await getClientIp();
  return ip !== null && allowedIps.includes(ip);
};
